import axios from 'axios';
import Qs from 'qs';
import appconf from "../appconf";
import notAuthorized from './interceptors/notAuthorized';

const apiUrl = appconf.api.URL;

const instanceBlob = axios.create({
  baseURL: apiUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
  responseType: 'arraybuffer',
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: "brackets" })
})


instanceBlob.interceptors.response.use(...notAuthorized);


export default instanceBlob;
